import React from 'react'
import { SvgIcon, SvgIconProps } from '@material-ui/core'

export const SearchBubbleIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} width="100" height="100" viewBox="15 0 98 98" fill="none">
		<path
			d="M70.8044 13.4701C82.9287 14.7705 95.7691 13.2328 103.429 18.9887C111.128 24.8057 113.646 37.9161 114.468 50.7547C115.273 63.6916 114.398 76.2582 107.691 81.9417C100.928 87.6625 88.3496 86.4016 77.9114 86.3422C67.4174 86.32 59.008 87.5363 47.4732 86.2815C35.8825 85.0637 21.1663 81.3747 17.6483 73.128C14.0907 64.8202 21.7313 51.9549 26.6374 39.6828C31.5038 27.3493 33.652 15.5109 40.4339 11.7896C47.2319 7.97026 58.6403 12.1086 70.8044 13.4701Z"
			fill="#E3DFFD"
		/>
		<g filter="url(#filter0_d)">
			<path
				d="M52.6656 65.5078L56.5094 68.6068L46.7717 80.0596L42.9277 76.9606L52.6656 65.5078Z"
				fill="white"
			/>
		</g>
		<g filter="url(#filter1_d)">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M69.119 69.1812C79.7906 69.1812 88.4418 60.3698 88.4418 49.5005C88.4418 38.6312 79.7906 29.8198 69.119 29.8198C58.4473 29.8198 49.7961 38.6312 49.7961 49.5005C49.7961 60.3698 58.4473 69.1812 69.119 69.1812ZM69.119 76.1788C83.585 76.1788 95.3121 64.2345 95.3121 49.5005C95.3121 34.7665 83.585 22.8223 69.119 22.8223C54.6529 22.8223 42.9258 34.7665 42.9258 49.5005C42.9258 64.2345 54.6529 76.1788 69.119 76.1788Z"
				fill="white"
			/>
		</g>
		<g filter="url(#filter2_d)">
			<path
				d="M42.1224 72.9934C43.865 71.0167 46.9539 70.7649 49.0217 72.4309L51.8579 74.7163C53.9256 76.3823 54.189 79.3354 52.4464 81.3122L37.912 97.7982C36.1694 99.7748 33.0804 100.027 31.0127 98.3606L28.1765 96.0754C26.1088 94.4092 25.8454 91.4561 27.588 89.4795L42.1224 72.9934Z"
				fill="white"
			/>
		</g>
		<path
			d="M69.12 38.3447C66.8577 38.349 64.6456 39.0105 62.753 40.2486C60.8605 41.4866 59.3691 43.2479 58.4606 45.3179C57.552 47.3878 57.2655 49.6771 57.636 51.9068C58.0065 54.1365 59.018 56.2103 60.5472 57.8759C61.6395 59.0588 62.9651 60.0028 64.4405 60.6485C65.9159 61.2942 67.5092 61.6276 69.12 61.6276C70.7308 61.6276 72.324 61.2942 73.7995 60.6485C75.2749 60.0028 76.6004 59.0588 77.6927 57.8759C79.222 56.2103 80.2334 54.1365 80.6038 51.9068C80.9743 49.6771 80.6879 47.3878 79.7794 45.3179C78.8708 43.2479 77.3793 41.4866 75.4868 40.2486C73.5942 39.0105 71.3821 38.349 69.12 38.3447ZM69.12 59.321C66.7039 59.3172 64.3834 58.3774 62.6467 56.699C63.1739 55.4164 64.0708 54.3197 65.2234 53.5477C66.3761 52.7758 67.7324 52.3636 69.12 52.3636C70.5075 52.3636 71.8638 52.7758 73.0164 53.5477C74.1691 54.3197 75.066 55.4164 75.5933 56.699C73.8566 58.3774 71.5361 59.3172 69.12 59.321ZM66.7873 47.6675C66.7873 47.2065 66.9241 46.7559 67.1803 46.3726C67.4367 45.9894 67.801 45.6906 68.2272 45.5142C68.6536 45.3378 69.1226 45.2916 69.575 45.3816C70.0275 45.4715 70.4432 45.6935 70.7694 46.0195C71.0957 46.3454 71.3179 46.7608 71.4079 47.2128C71.4979 47.6649 71.4517 48.1335 71.2751 48.5595C71.0985 48.9853 70.7995 49.3493 70.416 49.6053C70.0324 49.8615 69.5813 49.9982 69.12 49.9982C68.5013 49.9982 67.908 49.7526 67.4704 49.3155C67.033 48.8785 66.7873 48.2857 66.7873 47.6675ZM77.1795 54.6596C76.1373 52.8786 74.5334 51.4934 72.619 50.7206C73.2129 50.048 73.5998 49.2182 73.7334 48.3311C73.8671 47.444 73.7416 46.5373 73.3723 45.7196C73.0028 44.9019 72.4051 44.2082 71.6508 43.7215C70.8966 43.235 70.0177 42.9761 69.12 42.9761C68.2221 42.9761 67.3434 43.235 66.589 43.7215C65.8348 44.2082 65.2372 44.9019 64.8677 45.7196C64.4983 46.5373 64.3729 47.444 64.5065 48.3311C64.64 49.2182 65.027 50.048 65.6209 50.7206C63.7064 51.4934 62.1026 52.8786 61.0604 54.6596C60.23 53.2461 59.7911 51.6373 59.7891 49.9982C59.7891 47.5257 60.7722 45.1544 62.5221 43.406C64.272 41.6576 66.6453 40.6754 69.12 40.6754C71.5947 40.6754 73.968 41.6576 75.7179 43.406C77.4678 45.1544 78.4508 47.5257 78.4508 49.9982C78.4488 51.6373 78.01 53.2461 77.1795 54.6596Z"
			fill="#44444F"
		/>
		<path
			d="M43.1701 76.9207C43.5114 76.5203 43.4634 75.9191 43.0629 75.5778C42.6625 75.2366 42.0613 75.2846 41.72 75.685L30.3964 88.973C30.0552 89.3735 30.1031 89.9747 30.5036 90.3159C30.904 90.6572 31.5053 90.6092 31.8465 90.2088L43.1701 76.9207Z"
			fill="#7D6EF1"
		/>
		<path
			d="M51.147 69.9952C51.3314 69.7788 51.3055 69.4539 51.0891 69.2695C50.8727 69.085 50.5478 69.111 50.3634 69.3274L49.0463 70.873C48.8618 71.0894 48.8878 71.4143 49.1042 71.5987C49.3206 71.7831 49.6455 71.7572 49.8299 71.5408L51.147 69.9952Z"
			fill="#7D6EF1"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M64.2682 16.9299C64.2959 17.4539 63.9046 17.9017 63.3942 17.9301C48.0141 18.7867 36.253 31.8493 37.0558 47.0435C37.0834 47.5675 36.6922 48.0153 36.1818 48.0437C35.6715 48.0721 35.2353 47.6704 35.2077 47.1464C34.3464 30.8449 46.9521 16.9428 63.294 16.0327C63.8043 16.0042 64.2405 16.406 64.2682 16.9299Z"
			fill="#7D6EF1"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M103.031 46.1069C103.534 46.0787 103.964 46.4774 103.991 46.9976C104.926 64.8164 93.3284 80.16 77.8428 81.0283C77.3396 81.0565 76.9095 80.6577 76.8822 80.1376C76.8549 79.6175 77.2407 79.173 77.7439 79.1448C92.017 78.3444 103.061 64.1049 102.169 47.0997C102.142 46.5796 102.528 46.1351 103.031 46.1069Z"
			fill="#7D6EF1"
		/>
		<defs>
			<filter
				id="filter0_d"
				x="16.9277"
				y="43.5078"
				width="65.5817"
				height="66.5518"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				/>
				<feOffset dy="4" />
				<feGaussianBlur stdDeviation="13" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.470833 0 0 0 0 0.470833 0 0 0 0 0.470833 0 0 0 0.25 0"
				/>
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
				<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
			</filter>
			<filter
				id="filter1_d"
				x="16.9258"
				y="0.822266"
				width="104.386"
				height="105.357"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				/>
				<feOffset dy="4" />
				<feGaussianBlur stdDeviation="13" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.470833 0 0 0 0 0.470833 0 0 0 0 0.470833 0 0 0 0.25 0"
				/>
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
				<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
			</filter>
			<filter
				id="filter2_d"
				x="0.435547"
				y="49.3291"
				width="79.1633"
				height="80.1334"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				/>
				<feOffset dy="4" />
				<feGaussianBlur stdDeviation="13" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.316667 0 0 0 0 0.316667 0 0 0 0 0.316667 0 0 0 0.25 0"
				/>
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
				<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
			</filter>
		</defs>
	</SvgIcon>
)

export default SearchBubbleIcon
